const MOBILE_W = 768

document.addEventListener('DOMContentLoaded', function () {
    addSwiperOnMobile('heroCarousel')
    onHandleEventTabs()
}, false);

window.addEventListener('resize', ( e ) => {
    addSwiperOnMobile('heroCarousel')
})


function addSwiperOnMobile( id ) {
    let slide = document.getElementById(id)
    if( undefined != slide ) {
        let heroCarousel = new Swiper( "#" + id, { 
            pagination: {
                el: ".swiper-pagination-hero",
                clickable: true
            } 
        })
        let actualWidth = document.body.clientWidth
        if( actualWidth > MOBILE_W ) {
            heroCarousel.destroy(true, true)
        } else {
            heroCarousel.slidesPerView = 1
            heroCarousel.loop = false
            heroCarousel.spaceBetween = 30
        }
    } 
}

const onHandleEventTabs = () => {
    let tabsContainer = document.getElementById('tabs-container');
    if( undefined != tabsContainer ) {
        let tabs = tabsContainer.getElementsByClassName('tab')
        Array.from(tabs).forEach( tab => {
            tab.addEventListener( 'click', ( (e) => {
                Array.from(tabs).forEach( el => { 
                    el.classList.remove('selected')
                })
                tab.classList.add('selected');
                let content = tab.dataset.content;
                onSelectEventTab( content );
            }))
        });
    }
}

const onSelectEventTab = ( id ) => {
    let eventsContent = document.getElementById('events-content');
    if( undefined != eventsContent ) {
        let contents = eventsContent.getElementsByClassName('tab-content');
        Array.from(contents).forEach( content => {
            content.classList.remove( 'selected' )
        })
        let selectedContent = document.getElementById( id );
        selectedContent.classList.add( 'selected' )
    } 
}